import React, { Component } from 'react';
import { Form } from 'antd';
import { comma } from '../../lib/util/numberUtil';
import CloseIcon from '../../img/body/close.png';
import image from '../../res/image';
import Const from "../../const";

class CardDetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  onClose = () => {
    this.setState({
      blindMsgInputModalOpen: false,
      isEditMode: false,
    });
    this.props.close();
  };

  render() {
    const { data, isOpen } = this.props;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 },
      },
    };
    const skinType = Const.skinType.toUpperCase();
    return (
      <React.Fragment>
        {isOpen ? (
          <React.Fragment>
            <Form
              ref={this.formRef}
              {...formItemLayout}
              onFinish={this.handleSubmit}>
              <div
                className="Modal-detail-overlay"
                onClick={() => this.onClose()}
              />

              <div className="Modal-detail ddm" style={{ textAlign: 'left' }}>
                {/* 타이틀 */}

                <div className="detail-title">
                  <div>카드 결제내역 상세보기</div>
                  <div onClick={() => this.onClose()}>
                    <img style={{ display: 'inline' }} src={image.closeIcon} alt="" />
                  </div>
                </div>

                {/* 컨텐츠 */}
                <div className="detail-content">
                  <div className="detail-content-box cardpayment">
                    <div>
                      주문번호 : <p>{data.idx}</p>
                    </div>
                    <div
                      className={skinType === "GOGOIT" ? "gogoit-detail-bg addr mobileoff" : "detail-bg addr mobileoff"}
                      // style={{ width: 625 }}
                    >
                      <div>
                        고객주소 :
                        <ul>
                          <li>
                            <p> 도로명 </p> {data.custAddr1}{' '}
                          </li>
                          <li>
                            <p> 지번 </p> {data.custAddr3}{' '}
                          </li>
                          <li>
                            <p> 상세주소 </p> {data.custAddr2}{' '}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className={skinType === "GOGOIT" ? "gogoit-detail-bg addr mobile" : "detail-bg addr mobile"}>
                      <div>
                        고객주소 :
                        <ul>
                          <li>
                            <p> 도로명 </p> {data.custAddr1}{' '}
                          </li>
                          <li>
                            <p> 지번 </p> {data.custAddr3}{' '}
                          </li>
                          <li>
                            <p> 상세주소 </p> {data.custAddr2}{' '}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div>
                      전화번호 : <p>{data.custPhone}</p>
                    </div>
                  </div>

                  <div className="card-content-sub">
                    <div
                      className="card-detail-bg1"
                      // style={{ width: 680 }}
                    >
                      기사이름 :{' '}
                      <div>
                        {data.riderName !== null &&
                          `${data.riderName} ( ${data.riderPhone} )`}
                      </div>
                    </div>
                    <div
                      className="card-detail-bg1"
                      // style={{ width: 680 }}
                    >
                      결제금액 :<div>{comma(data.price + data.tax)}원</div>
                    </div>

                    <div className="card-detail-bg1">
                      카드사 :<div>{JSON.parse(data.reserved1).message1}</div>
                      <th>
                        카드번호 :<div>{JSON.parse(data.reserved1).cardNo}</div>
                      </th>
                    </div>

                    <div
                      className="card-detail-bg1"
                      // style={{ width: 680 }}
                    >
                      승인번호 :<div>{JSON.parse(data.reserved1).authNum}</div>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </React.Fragment>
        ) : null}
      </React.Fragment>
    );
  }
}

export default CardDetailModal;
